import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
} from "reactstrap";
import Switch from "COMPONENTS/CommonComponents/Switch/Switch";

import { getMessage } from "CONFIG/i18n";

// Actions
import { organisationAction } from "CONFIG/ActionFactory";

import "../SuperAdmin/Organisations/AddOrganization.less";
import "../App/App.less";

import { APP_CONFIG } from "UTILS/Constants";
import { ERROR } from "UTILS/Constants";
import modalScrollBar from "../ModalScrollBar/ModalScrollBar";

class UpdateProfileModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      userProfileData: {
        first_name: this.props.userProfileData.first_name,
        last_name: this.props.userProfileData.last_name,
        role: this.props.userProfileData.role,
        email: this.props.userProfileData.email,
        status: this.props.userProfileData.status,
        id: this.props.userProfileData.id
      },
      image_file: "",
      logo: this.props.logoUrl,
      image_data: "",
      is_image_changed: false,
      screenWidth: window.innerWidth,
      isOperator: this.props.userProfileData.isOperator,
      operatorSkills: this.props.userProfileData.operatorSkills,
    };
    window.addEventListener('resize', this.updateSize);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.userProfileData, prevProps.userProfileData)) {
      let userProfileData = Object.assign({}, this.props.userProfileData);
      this.setState({ userProfileData: userProfileData });
    }
    if (this.props.logoUrl !== prevProps.logoUrl) {
      this.setState({
        logo: this.props.logoUrl
      });
    }
    if (this.props.userProfileData.isOperator !== prevProps.userProfileData.isOperator) {
      this.setState({ isOperator: this.props.userProfileData.isOperator });
    }
    if (!_.isEqual(this.props.userProfileData.operatorSkills, prevProps.userProfileData.operatorSkills)) {
      this.setState({ operatorSkills: this.props.userProfileData.operatorSkills });
    }
  }
  
  componentWillUnmount(){
    window.removeEventListener('resize', this.updateSize);
  }

  updateSize = (event) =>{
    this.setState({screenWidth: window.innerWidth});
  }

  handleSaveClick = () => {
    if (!this.isEdited()) {
      this.props.toggle();
      return;
    }

    if (!this.isValidData()) {
      return;
    }
    
    let formData = new FormData();
    formData.append("file", this.state.image_data);
    formData.append("customerId", this.props.customerId);
    let data = Object.assign(
      {},
      {
        firstName: this.state.userProfileData.first_name,
        lastName: this.state.userProfileData.last_name,
        role: this.state.userProfileData.role,
        username: this.state.userProfileData.email
      }
    );
    this.setState({ errorMessage: "" });
    if (this.state.is_image_changed) {
      this.uploadImage(formData, data);
    } else {
      this.props.handleSaveClick(data, errorMessage => {
        this.setState({ errorMessage: errorMessage });
      });
    }
  };

  handleCancelClick = () => {
    this.setStateToProps();
    this.props.toggle();
  };

  handleInputChange = event => {
    let userProfileData = this.state.userProfileData;
    userProfileData[event.target.name] = event.target.value;
    this.setState({ userProfileData: userProfileData,errorMessage:"" });
  };

  renderButtons = () => {
    if(this.props.isSSOLogin) {
      return(
        <div className="permissionButtons">
          <Button
            className="buttons borderBtn bgwhite"
            onClick={this.handleCancelClick}
          >
            {getMessage("CLOSE")}
          </Button>
        </div>
      );
    } else { 
      return (
        <div className="permissionButtons">
          <Button
            className="buttons borderBtn bgwhite mr-2"
            onClick={this.handleCancelClick}
          >
            {getMessage("CANCEL")}
          </Button>
          <Button
            onClick={this.handleSaveClick}
            className="buttons customBtn whiteOnClick ml-2"
          >
            {getMessage("SAVE")}
          </Button>
        </div>
      );
    }
  }

  isValidData = () => {
    let UserDetail = this.state.userProfileData;
    if (!UserDetail.first_name) {
      this.setState({ errorMessage: getMessage("INVALID_FIRST_NAME") });
      return false;
    }
    if (!UserDetail.last_name) {
      this.setState({ errorMessage: getMessage("INVALID_LAST_NAME") });
      return false;
    }
    
    return true;
  };

  isEdited = () => {
    if (
      this.state.userProfileData.first_name !==
        this.props.userProfileData.first_name ||
      this.state.userProfileData.last_name !==
        this.props.userProfileData.last_name ||
      this.state.userProfileData.role !== this.props.userProfileData.role ||
      this.state.userProfileData.email !== this.props.userProfileData.email ||
      this.state.is_image_changed
    ) {
      return true;
    } else return false;
  };

  setStateToProps = () => {
    this.setState({
      userProfileData: {
        first_name: this.props.userProfileData.first_name,
        last_name: this.props.userProfileData.last_name,
        role: this.props.userProfileData.role,
        email: this.props.userProfileData.email,
        status: this.props.userProfileData.status,
        id: this.props.userProfileData.id
      },
      errorMessage: "",
      image_file: "",
      logo: this.props.logoUrl,
      image_data: "",
      is_image_changed: false
    });
  };

  handleOrgLogoChange = event => {
    if (event.target.files) {
      this.setState({
        logo: URL.createObjectURL(event.target.files[0]),
        logoUrl: event.target.files[0],
        image_data: event.target.files[0],
        is_image_changed: true
      });
    }
  };

  uploadImage = (formData, data) => {
    organisationAction.uploadOrgLogoStatusAction(formData).then(
      response_data => {
        data.logoUrl = response_data.data.data.fileUrl;
        organisationAction
        .updateUrl(response_data.data.data.fileUrl, this.props.customerId)
        .then(response_data => {});
        organisationAction.setLogoUrl(response_data.data.data.fileUrl);
        this.props.handleSaveClick(data, errorMessage => {
          this.setState({ errorMessage: errorMessage });
        });
        this.setState({ is_image_changed: false });
      },
      error => {
        if(error.code !== ERROR.NOT_AUTHORIZED)
          this.setState({ errorMessage: error.message });
      }
    );
  };

  renderSwitch = (flag) => {
    return (
      <Switch
        switchOn={flag}
        toggleSwitch={()=>{}}
        disabled={true}
      />
    )
  }

  renderSkills = (skills) => {
    if (!skills || skills.length === 0) return null;

    const elem = skills.map((skill) => {
      return (
        <Row key={skill.id}>
          <Col>
            <Input
              type={'checkbox'}
              name={'skills'}
              data-id={skill.id}
              checked={skill.isSelected}
              onChange={()=>{}}
              disabled={true}
            />
            {" "}
            {skill.name}
          </Col>
        </Row>
      )
    });

    return elem;
  }

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        className="modalMainDiv addOrganisationModal modal-width-50"
        toggle={this.handleCancelClick}
        backdrop="static"
        centered
      >
        <ModalHeader className="popupHeader p-2">
          {getMessage("MY_PROFILE")}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup className="d-flex mb-2">
              <Label className="label modal-label col-md-3 col-4">{getMessage("TYPE_OF_USER")}</Label>
              <Input
                type="text"
                name="role"
                id="role"
                className="inputFormControl col-md-9 col-7"
                onChange={this.handleInputChange}
                value={_.capitalize(getMessage(this.state.userProfileData.role))}
                disabled
              ></Input>
            </FormGroup>

            <FormGroup className="d-flex mb-2">
              <Label className="label modal-label col-md-3 col-4">{getMessage("ACCOUNT_ID")}</Label>
              <Input
                type="email"
                name="email"
                id="email"
                onChange={this.handleInputChange}
                className="inputFormControl col-md-9 col-7"
                value={this.state.userProfileData.email}
                disabled
              />
            </FormGroup>
            <FormGroup className="d-flex mb-2">
              <Label className="label modal-label col-md-3 col-4">{getMessage("LAST_NAME")}</Label>
              <Input
                type="text"
                name="last_name"
                onChange={this.handleInputChange}
                className="inputFormControl col-md-9 col-7"
                maxLength="50"
                value={this.state.userProfileData.last_name}
                disabled={this.props.isSSOLogin}
              />
            </FormGroup>
            <FormGroup className="d-flex mb-2">
              <Label className="label modal-label col-md-3 col-4">{getMessage("FIRST_NAME")}</Label>
              <Input
                type="text"
                name="first_name"
                onChange={this.handleInputChange}
                className="inputFormControl col-md-9 col-7"
                maxLength="50"
                value={this.state.userProfileData.first_name}
                disabled={this.props.isSSOLogin}
              />
            </FormGroup>
            <FormGroup className="d-flex mb-2">
              <Label className="label modal-label col-md-3 col-4">{getMessage("OPERATOR")}</Label>
              {this.renderSwitch(this.state.isOperator)}
            </FormGroup>
            {
              (this.state.isOperator) ? (
                <FormGroup className="d-flex mb-2">
                  <Label className="label modal-label col-md-3 col-4">{getMessage("SKILLS")}</Label>
                  <Col className="d-flex flex-column">
                    {this.renderSkills(this.state.operatorSkills)}
                  </Col>
                </FormGroup>
              ) : null
            }
            <div className="modal-errors">{this.state.errorMessage}</div>
          </Form>
        </ModalBody>
        <ModalFooter className="permissionButtons">
          {this.renderButtons()}
        </ModalFooter>
      </Modal>
    );
  }
}
export default modalScrollBar(UpdateProfileModal); 

